import axios  from "../../services/axios";
import { constants } from '../../constants';
import { toGMT } from '../../common';
export const listOrders = async ({ filters, page, perPage,action }) => {
  
  try {
    const response = await axios.get(`/order/all`, {
      params: {
        from_date: filters?.from_date ? toGMT(filters.from_date, '00:00:00') : '',
        to_date: filters?.to_date ? toGMT(filters.to_date, '23:59:59') : '',
        vanid: filters?.vanid || '',
        customername: filters?.customername || '',
        page,
        perPage,
        action:action
      },
    });
  
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch orders. Please try again later.';
    throw new Error(message);
  }
  };
export const downloadOrders = async ({ filters, action }) => {
  try {
    const response = await axios.get(`/order/all`, {
      params: {
        from_date: filters?.from_date ? toGMT(filters.from_date, '00:00:00') : '',
        to_date: filters?.to_date ? toGMT(filters.to_date, '23:59:59') : '',
        vanid: filters?.vanid || '',
        customername: filters?.customername || '',
        action: action || 'download'
      },
      responseType: 'blob' // IMPORTANT for file download
    });
    return response;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to download orders. Please try again later.';
    throw new Error(message);
  }
};
  export const fetchOrderDetails = async (orderid) => {
  try {
    const response = await axios.get(`/order/view/${orderid}`);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch order details. Please try again later.';
    throw new Error(message);
  }
};

export const updateOrder = async (orderData)=>{
  try {
    const response = await axios.put('/order/update-payment', orderData);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to update the order. Please try again.';
    throw new Error(message);
  }
}
